import {
    selectSymbolMessages,
    selectSymbolTileState,
} from 'widgets/symbolTile/store/data/selectors';
import { useSelector } from 'react-redux';
import State from 'store/State';

export const useSymbolTileStreamData = (symbol?: string) =>
    useSelector((s: State) => selectSymbolTileState(s, symbol));

export const useSymbolMessages = (symbol?: string) =>
    useSelector((s: State) => selectSymbolMessages(s, symbol));
